import { CardDescription, CardTitle } from '@apollo/orbit';
import React, { useMemo } from 'react';

import { ShimmerLoading } from 'src/components/common/loading/ShimmerLoading';
import { useQueryParam } from 'src/hooks/useQueryParam';
import {
  TimeRangeOption,
  defaultTimeRange,
  printTimeRangeLabel,
} from 'src/lib/config/timeRangeOptions';
import { format } from 'src/lib/format';

import { FieldMetrics } from '../../useCurrentField';

interface Props {
  loading?: Boolean;
  fieldMetrics: FieldMetrics;
  showEmptyState?: boolean;
}

export const FieldPageClientHeading = ({
  loading,
  fieldMetrics,
  showEmptyState,
}: Props) => {
  const range = useQueryParam('range');
  const printRange = useMemo(() => {
    const rangeValue = range || defaultTimeRange;
    return rangeValue === 'custom'
      ? 'custom range'
      : printTimeRangeLabel(rangeValue as TimeRangeOption).toLowerCase();
  }, [range]);
  const { totalClients, totalOperations } = fieldMetrics;

  return (
    <>
      <CardTitle>Clients &amp; operations</CardTitle>
      {loading ? (
        <ShimmerLoading className="h-6 w-64" />
      ) : showEmptyState ? (
        // render CardDescription even though we show an empty state to
        // maintain the height of the card header
        <CardDescription aria-hidden>&nbsp;</CardDescription>
      ) : (
        <CardDescription>
          Used by{' '}
          <b className="font-semibold">
            {totalClients} {format.pluralize(totalClients, 'client')}
          </b>{' '}
          and{' '}
          <b className="font-semibold">
            {totalOperations} {format.pluralize(totalOperations, 'operation')}
          </b>{' '}
          in the {printRange}.
        </CardDescription>
      )}
    </>
  );
};
